import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Layout from "../../../../layout";
import Header from './header/header';
import News from './news/news';
import Tags from './tags/tags';

const useStyles = makeStyles((theme) => ({
    root: {
        ...theme.grid.gridMdContent,
        margin: '70px auto',
        maxWidth: '100%'
    },
    gridLoading: {
        ...theme.grid.gridMdContent,
        display: 'flex',
        justifyContent: 'center',
        marginTop: 20
    },

}));

export default function Index() {

    let classes = useStyles();

    let [stateNews, setStateNews] = useState([]);
    let [stateTags, setStateTags] = useState([]);
    let [tags, setTags] = useState(null);

    return (
        <Layout>
            <div className={classes['root']}>
                <Header tags={tags} setTags={setTags} />
                <div className={classes['grid']}>
                    {
                        !tags && (<News
                            stateNews={stateNews}
                            setStateNews={setStateNews}
                            tags={tags}
                            setTags={setTags}
                        />)
                    }
                    {
                        tags && (<Tags
                            stateTags={stateTags}
                            setStateTags={setStateTags}
                            tags={tags}
                            setTags={setTags}
                        />)
                    }

                </div>
            </div>
            <hr />
        </Layout>
    );
}
